export default "__VITE_ASSET__RA2vMJ1d__"